import { DivStyle, H1Style, H2Style, SpanStyle, TextStyle } from 'styles/intro/common';

export function Div({ children, onClick, ...props }) {
  return (
    <DivStyle onClick={onClick} {...props}>
      {children}
    </DivStyle>
  );
}

export function RowDiv({ children, onClick, ...props }) {
  return (
    <DivStyle $display="flex" $flexDirection="row" onClick={onClick} {...props}>
      {children}
    </DivStyle>
  );
}

export function ColDiv({ children, onClick, ...props }) {
  return (
    <DivStyle $display="flex" $flexDirection="column" onClick={onClick} {...props}>
      {children}
    </DivStyle>
  );
}

// text

export function Span({ children, ...props }) {
  return <SpanStyle {...props}>{children}</SpanStyle>;
}
export function Text({ children, ...props }) {
  return <TextStyle {...props}>{children}</TextStyle>;
}

export function BoldText({ children, ...props }) {
  return (
    <TextStyle $fontWeight={700} {...props}>
      {children}
    </TextStyle>
  );
}
